import {stepCompanyProfile, stepCompanyTransactions} from "./stepsConfig.ts"
import {TStep} from "./types"

export const steps = [stepCompanyProfile, stepCompanyTransactions] as TStep[]
